export const DIALOG_RECOVERY = '是否确定恢复？';
export const DIALOG_RESTART = '是否确定远程重启？';
export const DIALOG_CONTROL = '是否确定远程遥控？';

export enum PopoverTypeEnum {
  WORK_ORDER_POPOVER = 'work-order-popover',
  JIRA_SUBMIT_POPOVER = 'jira-submit-popover',
}

export enum TakeOverSource {
  MONITOR = 'MONITOR',
  MINI_MONITOR = 'MINI_MONITOR',
  REMOTE_JOYSTICK = 'REMOTE_JOYSTICK',
}

export const TakeOverSourceMap = new Map([
  [
    'MONITOR',
    {
      name: '监控',
      code: 'MONITOR',
    },
  ],
  [
    'MINI_MONITOR',
    {
      name: '小程序',
      code: 'MINI_MONITOR',
    },
  ],
  [
    'REMOTE_JOYSTICK',
    {
      name: '驾舱',
      code: 'REMOTE_JOYSTICK',
    },
  ],
  [
    'WORKBENCH_MONITOR',
    {
      name: '小哥工作台',
      code: 'WORKBENCH_MONITOR',
    },
  ],
]);
